import { PaymentFlowType, PndType, SourceType } from "@/enums/enums";
import { GetFileType } from "@/helper/shareHelper";
import { SearchPndFormModel } from "@/model/table/tableViewModel";

export function ConvertToWhtCertificateTable(_whtCertificateDetail: Array<any>, check: boolean) {
  const whtCertificateDetail = {
    countWhtCertificate: _whtCertificateDetail.length,
    detailList: [] as any,
  };

  if (_whtCertificateDetail && _whtCertificateDetail.length > 0) {
    _whtCertificateDetail.forEach((whtItemModel: any) => {
      const data = {
        contactId: whtItemModel.contactId,
        itemList: whtItemModel.itemList,
        subTotal: whtItemModel.subTotal,
        id: whtItemModel.whtCertificateId,
        whtDate: whtItemModel.whtDate,
        whtNumber: whtItemModel.whtNumber,
        whtTotal: whtItemModel.whtTotal,
        sourceId: whtItemModel.sourceId,
        sourceType: whtItemModel.sourceType,
        referenceOne: whtItemModel.referenceOne,
        referenceTwo: whtItemModel.referenceTwo,
        check: check,
        disabled: false,
      };
      whtCertificateDetail.detailList.push(data);
    });
  }

  return whtCertificateDetail;
}
export function ConvertToSearchPndFormRequest(searchTransaction: any) {
  const searchTransactionRequest: SearchPndFormModel = {
    pndNumber: searchTransaction.formNumber ? searchTransaction.formNumber : "",
    fromDate: searchTransaction.fromDate,
    toDate: searchTransaction.toDate,
    fromSubTotal: searchTransaction.fromTransactionAmount ? searchTransaction.fromTransactionAmount.ToNumber() : null,
    toSubTotal: searchTransaction.toTransactionAmount ? searchTransaction.toTransactionAmount.ToNumber() : null,
    fromWhtTotal: searchTransaction.fromNetTaxCreditAmount ? searchTransaction.fromNetTaxCreditAmount.ToNumber() : null,
    toWhtTotal: searchTransaction.toNetTaxCreditAmount ? searchTransaction.toNetTaxCreditAmount.ToNumber() : null,
    filingType: searchTransaction.filingType,
  };
  return searchTransactionRequest;
}
export function ConvertToPndDetailById(_pndDetail: any) {
  const pndDetail = {
    countWhtCertificate: _pndDetail.countWhtCertificate,
    filingCaseType: _pndDetail.filingCaseType,
    filingRound: _pndDetail.filingRound,
    filingType: _pndDetail.filingType,
    isClosingEntry: _pndDetail.isClosingEntry,
    isDeleted: _pndDetail.isDeleted,
    isFiled: _pndDetail.isFiled,
    isPaid: _pndDetail.isPaid,
    isGotReceipt: _pndDetail.isGotReceipt,
    netAmount: _pndDetail.netAmount,
    pndDate: _pndDetail.pndDate,
    pndId: _pndDetail.pndId,
    pndNumber: _pndDetail.pndNumber,
    pndType: _pndDetail.pndType,
    status: _pndDetail.status,
    subTotal: _pndDetail.subTotal,
    surchargeAmount: _pndDetail.surchargeAmount,
    whtForInsertPndModelList: _pndDetail.whtForInsertPndModelList,
    whtTotal: _pndDetail.whtTotal,
    actionGotReceipt: _pndDetail.actionGotReceipt,
    createDateTime: new Date(_pndDetail.createDateTime),
  };
  return pndDetail;
}

export function ConvertToFileStoragePnd(fileStoragePndList: Array<any>) {
  const fileStoragePnd: any = [];

  if (fileStoragePndList.length > 0) {
    fileStoragePndList.forEach((item: any) => {
      fileStoragePnd.push({
        createDateTime: item.uploadDateTime,
        fileFullUrl: item.fileUrl,
        fileName: item.fileName,
        name: item.fileName,
        fileType: item.fileContentType ? item.fileContentType : GetFileType(item.fileName),
        id: item.fileId,
        userId: item.uploadUserId,
      });
    });
  }
  return fileStoragePnd;
}

export function ConvertToClosingEntryPndModelFromMongo(_closingEntryPndModelFromMongo: any) {
  const closingEntryPndModelFromMongo = {
    journalModel: _closingEntryPndModelFromMongo.journalModel,
    expenseModel: _closingEntryPndModelFromMongo.expenseModel,
    pndId: _closingEntryPndModelFromMongo,
    pndType: _closingEntryPndModelFromMongo.pndType,
    isClosingEntry: _closingEntryPndModelFromMongo.isClosingEntry,
  };

  return closingEntryPndModelFromMongo;
}

export function ConvertToUpdateIsFiledPnd(_pndIsFiledDetail: any, reference: string) {
  const pndUpdateIsFiledOption = {
    pndId: _pndIsFiledDetail.pndId,
    pndType: _pndIsFiledDetail.pndType,
    reference: reference,
    filedType: _pndIsFiledDetail.filedType,
    isFiled: _pndIsFiledDetail.isFiled,
    filingDate: _pndIsFiledDetail.filingDate,
  };

  return pndUpdateIsFiledOption;
}

export function ConvertToWhtDetailListForPnd(_whtList: any) {
  const whtList: any = [];
  if (_whtList && _whtList.length > 0) {
    _whtList.forEach((_whtItem: any) => {
      const wht = {
        id: _whtItem.id,
        number: _whtItem.number,
        subTotalForCalculateWht: _whtItem.subTotalForCalculateWht,
        whtTotal: _whtItem.whtTotal,
        pndType: _whtItem.pndType,
        date: _whtItem.date,
        isDeleted: _whtItem.isDeleted,
        transactionId: _whtItem.transactionId,
        transactionType: _whtItem.transactionType,
        items: _whtItem.items,
        contactId: _whtItem.contactId,
      };
      whtList.push(wht);
    });
  }
  return whtList;
}

export function ConvertToWhtDetailData(result: any) {
  const data: any = {
    id: result.id,
    number: result.number,
    subTotalForCalculateWht: result.subTotalForCalculateWht,
    whtTotal: result.whtTotal,
    pndType: result.pndType,
    date: result.date,
    isDeleted: result.isDeleted,
    transactionId: result.transactionId,
    transactionType: result.transactionType,
    items: result.items,
    contactId: result.contactId,
  };

  return data;
}

export function ConvertToCommentLogPnd(_commentList: Array<any>) {
  const commentList: any = [];

  if (_commentList.length > 0) {
    _commentList.forEach((item: any) => {
      commentList.push({
        actionDateTime: item.actionDateTime,
        actionUserId: item.actionUserId,
        commentId: item.commentId,
        commentLogType: item.commentLogType,
        data: item.data,
        note: item.note,
      });
    });
  }
  return commentList;
}

export function SliceArrayData(originalArray: any, sliceSize: number) {
  const result = [];
  for (let i = 0; i < originalArray.length; i += sliceSize) {
    const data = originalArray.slice(i, i + sliceSize);
    result.push(data);
  }
  return result;
}

export function PrepareUpdateCheckingWhtDatas(
  paymentFlowType: PaymentFlowType,
  pndType: PndType,
  periodDate: any,
  whtIdList: any,
  insertNo: number
) {
  const input = {
    paymentFlowType: paymentFlowType,
    pndType: pndType,
    periodDate: periodDate,
    whtIdList: whtIdList,
    insertNo: insertNo,
  };
  return input;
}

export function PrepareWhtCertificateBySourceId(sourceId: number) {
  const input = {
    sourceId: sourceId,
    sourceType: SourceType.PeakAccount,
  };
  return input;
}
